module.exports = __webpack_public_path__ + "img/reports.a6aeaf37.svg";